module.exports = __webpack_public_path__ + "img/功能架构.6f04d64f.png";